/* istanbul ignore file */
import useQuery, { QueryOptions } from 'hooks/useQuery';
import {
  getDoctors as action,
  getDoctorsReset as resetAction,
} from 'store/doctors/actions';
import { getDoctorsSelector as selector } from 'store/doctors/selectors';

const useDoctors = (params?: QueryOptions) => {
  const {
    data,
    loading,
    error,
    get: _get,
    reset,
    hasMore = true,
    page = 1,
  } = useQuery({
    action,
    resetAction,
    selector,
    ...params,
  });

  const get = (payload: any) => reset() && _get(payload);

  const loadMore = (payload: any) =>
    hasMore && _get({ ...payload, page: page + 1 });

  return { data, loading, error, get, loadMore, reset, hasMore };
};

export default useDoctors;
